import { jsx as _jsx } from "react/jsx-runtime";
import { Airport, Cinema, Digital, Hyperlocal, InfluencerMarketing, Magazine, Newspaper, Nontraditional, Outdoor, Radio, SportsMarketing, Television, } from './ToolIcons';
export const icons = {
    airport: {
        icon: Airport,
        color: '#00BCD6',
    },
    cinema: {
        icon: Cinema,
        color: '#3EAA7D',
    },
    digital: {
        icon: Digital,
        color: '#E4421E',
    },
    hyperlocal: {
        icon: Hyperlocal,
        color: '#89C440',
    },
    'influencer-marketing': {
        icon: InfluencerMarketing,
        color: '#009688',
    },
    magazine: {
        icon: Magazine,
        color: '#9364ED',
    },
    newspaper: {
        icon: Newspaper,
        color: '#F2994A',
    },
    nontraditional: {
        icon: Nontraditional,
        color: '#FF5607',
    },
    outdoor: {
        icon: Outdoor,
        color: '#EABD00',
    },
    radio: {
        icon: Radio,
        color: '#4E3BC9',
    },
    television: {
        icon: Television,
        color: '#EC1561',
    },
    'sports-marketing': {
        icon: SportsMarketing,
        color: '#3EAA7D',
    },
};
const index = (props) => {
    const { iconName, height, width, color } = props;
    const Icon = icons[iconName].icon;
    return (_jsx(Icon, { height: height, width: width, color: color ? color : icons[iconName].color }));
};
export default index;
